import { toast as originalToast } from 'react-toastify';
import Media from 'reactstrap/lib/Media';

const CustomComponent = ({ icon, content, inline }) => {
    if (typeof content !== 'string') return content;
    return (
        <Media>
            {icon && <Media className="align-self-center mr-3"><i className={icon}></i></Media>}
            <Media>{content}</Media>
        </Media>
    )
}

function CustomToast(name, icon, content, options) {
    originalToast[name](<CustomComponent icon={icon} content={content} {...options} />, options)
}

export const toast = {
    success: (content, options) => CustomToast('success', 'fas fa-check-circle text-success', content, options),
    error: (content, options) => CustomToast('error', 'fas fa-ban text-danger', content, options),
    warning: (content, options) => CustomToast('warning', 'fas fa-exclamation-circle text-warning', content, options),
    warn: (content, options) => CustomToast('warn', 'fas fa-exclamation-circle text-warning', content, options),
    dark: (content, options) => CustomToast('dark', '', content, options),
    info: (content, options) => CustomToast('info', '', content, options),
}
